//این کد وب ویتال‌ها (Web Vitals) صفحه مثل CLS، FID، FCP، LCP و TTFB را اندازه‌گیری می‌کند.
//اگر تابعی به نام onPerfEntry ارسال شود، مقادیر این شاخص‌ها را به آن ارسال می‌کند.
//برای تحلیل عملکرد و بهینه‌سازی سرعت سایت استفاده می‌شود.

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import("web-vitals").then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
